export default __webpack_public_path__ + "static/media/airrow.4747c68c.png";